<div class="pia-sectionsBlock">
  <div class="pia-sectionBlock-header">
    <h1 class="truncate" title="{{ pia.name }}">{{ pia.name }}</h1>
    <a
      class="pia-icons pia-icon-close-big"
      routerLink="/entries"
      title="{{ 'pia.sections.homepage_link' | translate }}"
    ></a>
  </div>

  <div class="pia-sectionBlock-structure" *ngIf="pia.structure_id">
    {{ "pia.sections.based_on_structure_name" | translate }}
    {{ pia.structure_name }}
  </div>

  <div class="pia-sectionBlock-category" *ngIf="pia.category">
    {{ "homepage.cards.category" | translate }} "{{ pia.category }}"
  </div>

  <div class="pia-sectionBlock-category" *ngIf="editMode !== 'local'">
    {{ "users.role.label" | translate }}: [<ng-container
      *ngFor="let item of editMode; let i = index"
      >{{ "users.role." + item | translate
      }}<span *ngIf="i < editMode.length - 1">, </span></ng-container
    >]
  </div>

  <div class="pia-sectionBlock-body" *ngIf="!loading; else statusSettingElse">
    <div
      *ngFor="let dataSection of data?.sections"
      [ngClass]="dataSection.title.split('.').join('-')"
    >
      <div class="pia-sectionBlock-title">
        {{ dataSection.title | translate }}
        <hr />
      </div>
      <ul
        class="pia-sectionBlock-list"
        *ngIf="pia && section && item && sidStatusService.itemStatus"
      >
        <ng-container *ngFor="let dataItem of dataSection?.items">
          <li *ngIf="!dataItem.hide">
            <a
              [routerLink]="[
                '/pia',
                pia.id,
                'section',
                dataSection.id,
                'item',
                dataItem.id
              ]"
              [ngClass]="{
                active: section.id == dataSection.id && item.id == dataItem.id
              }"
              class="truncate"
            >
              {{ dataItem.title | translate }}</a
            >
            <span
              *ngIf="
                sidStatusService.sidStatusIcon[
                  sidStatusService.itemStatus[
                    dataSection.id + '.' + dataItem.id
                  ]
                ]
              "
            >
              <fa-icon
                *ngIf="
                  sidStatusService.sidStatusIcon[
                    sidStatusService.itemStatus[
                      dataSection.id + '.' + dataItem.id
                    ]
                  ] == 'faPenToSquare'
                "
                [icon]="faPenToSquare"
              ></fa-icon>
              <fa-icon
                *ngIf="
                  sidStatusService.sidStatusIcon[
                    sidStatusService.itemStatus[
                      dataSection.id + '.' + dataItem.id
                    ]
                  ] == 'faPenToSquare,pia-fa-valid'
                "
                class="pia-fa-valid"
                [icon]="faPenToSquare"
              ></fa-icon>
              <fa-icon
                *ngIf="
                  sidStatusService.sidStatusIcon[
                    sidStatusService.itemStatus[
                      dataSection.id + '.' + dataItem.id
                    ]
                  ] == 'faGear'
                "
                [icon]="faGear"
              ></fa-icon>
              <fa-icon
                *ngIf="
                  sidStatusService.sidStatusIcon[
                    sidStatusService.itemStatus[
                      dataSection.id + '.' + dataItem.id
                    ]
                  ] == 'faGear,pia-fa-valid'
                "
                class="pia-fa-valid"
                [icon]="faGear"
              ></fa-icon>
              <fa-icon
                *ngIf="
                  sidStatusService.sidStatusIcon[
                    sidStatusService.itemStatus[
                      dataSection.id + '.' + dataItem.id
                    ]
                  ] == 'faSquareCheck'
                "
                class="pia-fa-valid"
                [icon]="faSquareCheck"
              ></fa-icon>
            </span>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <ng-template #statusSettingElse>
    <div
      class="pia-sectionBlock-body"
      style="position:relative; height: 150px;"
    >
      <app-loading-overlay
        [visibility]="true"
        [childMode]="true"
      ></app-loading-overlay>
    </div>
  </ng-template>
</div>

<div class="pia-validatePIABlock">
  <ng-container
    *ngIf="
      ((editMode.includes('validator') || editMode === 'local') &&
        sidStatusService.enablePiaValidation &&
        sidStatusService.enableDpoValidation) ||
        (sidStatusService.piaIsRefused && sidStatusService.enableDpoValidation);
      else defaultButton
    "
  >
    <a
      [routerLink]="['/pia', pia.id, 'section', '4', 'item', '4']"
      class="btn btn-green btn-active"
      *ngIf="sidStatusService.enablePiaValidation"
      >{{ "pia.sections.validate_pia" | translate }}</a
    >
    <a
      [routerLink]="['/pia', pia.id, 'section', '4', 'item', '5']"
      class="btn btn-red btn-active"
      *ngIf="sidStatusService.piaIsRefused"
      >{{ "pia.sections.refuse_pia" | translate }}</a
    >
  </ng-container>
  <ng-template #defaultButton>
    <a class="btn btn-inactive">{{
      "pia.sections.validate_pia" | translate
    }}</a>
  </ng-template>
</div>
